import { useCallback, useRef, useState } from 'react';
import { makePayment, PaymentPostInput } from 'src/utils/api/makePayment';

import { MakePaymentMutation } from '@/graphql/paymentMethods';

type GivingGaveParams = {
  amount: string;
  currency: string;
  frequency: string;
  fund: string;
  payment_method: string;
  start_date: string;
};

interface Props {
  onError: (error: unknown) => void;
  onSuccess: (data: MakePaymentMutation, firebaseParams: GivingGaveParams) => void;
}

interface MutateVariables {
  payment: PaymentPostInput;
}

export function useMakePayment({ onSuccess, onError }: Props) {
  const onSuccessRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const mutate = useCallback(async (variables: MutateVariables, firebaseParams: GivingGaveParams) => {
    setIsLoading(true);
    const response = await makePayment(variables);
    if (response.errors) {
      onErrorRef.current(new Error(response.errors[0].message));
    } else if (response.data) {
      onSuccessRef.current(response.data, firebaseParams);
    }
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    mutate,
  };
}
